import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { RounderUtil } from 'utils'

const PrecioFormGroup = ({ iError, iTouched, fIsSubmitting,vCantidad, handleChange, setFieldValue }) => {
  const onChange = React.useCallback(
    e => {
      handleChange(e)

      const valorStr = e.target.value
      const valorNumero = parseFloat(valorStr || '0')

      const total = RounderUtil.round(valorNumero * vCantidad)
      setFieldValue('total', total)
    },
    [setFieldValue, vCantidad, handleChange]
  )

  return (
    <Form.Group>
      <Form.Label text='PRECIO' htmlFor='producto-adicional-input-precio' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='precio'>
          {({ field }) => (
            <Form.InputNumber {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} onChange={onChange} id='producto-adicional-input-precio' />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(PrecioFormGroup)
